import {CSSProperties, FC} from 'react';

import {Icon360Avito} from './360-avito';
import {IconAbsBmw} from './abs-bmw';
import {IconAbs} from './abs';
import {IconAcceleration} from './acceleration';
import {IconAirbagBmw} from './airbag-bmw';
import {IconAirbag} from './airbag';
import {IconArrowBackOvalAvito} from './arrow-back-oval-avito';
import {IconArrowDownGenericV2} from './arrow-down-generic-v2';
import {IconArrowDownNissan} from './arrow-down-nissan';
import {IconArrowDown} from './arrow-down';
import {IconArrowGreenLeftAvito} from './arrow-green-left-avito';
import {IconArrowGreenRightAvito} from './arrow-green-right-avito';
import {IconArrowLeftGenericV2} from './arrow-left-generic-v2';
import {IconArrowLeftNissan} from './arrow-left-nissan';
import {IconArrowLeft} from './arrow-left';
import {IconArrowRightGenericV2} from './arrow-right-generic-v2';
import {IconArrowRightNissan} from './arrow-right-nissan';
import {IconArrowRight} from './arrow-right';
import {IconArrowUpGenericV2} from './arrow-up-generic-v2';
import {IconArrowUpNissan} from './arrow-up-nissan';
import {IconArrowUp} from './arrow-up';
import {IconAutoAvito} from './auto-avito';
import {IconAxleLoadBmw} from './axle-load-bmw';
import {IconAxleLoad} from './axle-load';
import {IconBatteryBmw} from './battery-bmw';
import {IconBattery} from './battery';
import {IconBeltBmw} from './belt-bmw';
import {IconBelt} from './belt';
import {IconBurgerBmw} from './burger-bmw';
import {IconBurgerNissan} from './burger-nissan';
import {IconBurger} from './burger';
import {IconCalcBmw} from './calc-bmw';
import {IconCalcNissan} from './calc-nissan';
import {IconCalc} from './calc';
import {IconCalendarBmw} from './calendar-bmw';
import {IconCalendarNissan} from './calendar-nissan';
import {IconCalendar} from './calendar';
import {IconCancelBmw} from './cancel-bmw';
import {IconCancelNissan} from './cancel-nissan';
import {IconCancel} from './cancel';
import {IconCarAvito} from './car-avito';
import {IconCarFrontBmw} from './car-front-bmw';
import {IconCarFrontNissan} from './car-front-nissan';
import {IconCarFront} from './car-front';
import {IconCarSeatLeft} from './car-seat-left';
import {IconCarSeatRight} from './car-seat-right';
import {IconCarryingBmw} from './carrying-bmw';
import {IconCarryingNissan} from './carrying-nissan';
import {IconCarrying} from './carrying';
import {IconCartBmw} from './cart-bmw';
import {IconCartNissan} from './cart-nissan';
import {IconCart} from './cart';
import {IconCheckBmw} from './check-bmw';
import {IconCheckNissan} from './check-nissan';
import {IconCheck} from './check';
import {IconCheckinShieldAvito} from './checkin-shield-avito';
import {IconCheckmarkGenericV2} from './checkmark-generic-v2';
import {IconChevronLeftBmw} from './chevron-left-bmw';
import {IconChevronLeftNissan} from './chevron-left-nissan';
import {IconChevronLeft} from './chevron-left';
import {IconChevronRightBmw} from './chevron-right-bmw';
import {IconChevronRightNissan} from './chevron-right-nissan';
import {IconChevronRight} from './chevron-right';
import {IconCompare2} from './compare-2';
import {IconCompare} from './compare';
import {IconDocumentBmw} from './document-bmw';
import {IconDocumentNissan} from './document-nissan';
import {IconDocument} from './document';
import {IconDownloadBmw} from './download-bmw';
import {IconDownloadNissan} from './download-nissan';
import {IconDownload} from './download';
import {IconEcoBmw} from './eco-bmw';
import {IconEco} from './eco';
import {IconEditBmw} from './edit-bmw';
import {IconEditNissan} from './edit-nissan';
import {IconEdit} from './edit';
import {IconEngine2} from './engine-2';
import {IconEngineBmw} from './engine-bmw';
import {IconEngine} from './engine';
import {IconEspBmw} from './esp-bmw';
import {IconEspNissan} from './esp-nissan';
import {IconEsp} from './esp';
import {IconEye} from './eye';
import {IconFacebook} from './facebook';
import {IconFilter} from './filter';
import {IconFoursquare} from './foursquare';
import {IconFuel2} from './fuel-2';
import {IconFuelBmw} from './fuel-bmw';
import {IconFuel} from './fuel';
import {IconGlobe} from './globe';
import {IconGooglePlus} from './google-plus';
import {IconGridNissan} from './grid-nissan';
import {IconGrid} from './grid';
import {IconHeart2} from './heart-2';
import {IconHeartBlack} from './heart-black';
import {IconHeart} from './heart';
import {IconHeightBmw} from './height-bmw';
import {IconHeightNissan} from './height-nissan';
import {IconHeight} from './height';
import {IconInfoBmw} from './info-bmw';
import {IconInfoNissan} from './info-nissan';
import {IconInfo} from './info';
import {IconInfo2} from './info2';
import {IconInstagram} from './instagram';
import {IconInteriorAvito} from './interior-avito';
import {IconLengthBmw} from './length-bmw';
import {IconLength} from './length';
import {IconLightsBmw} from './lights-bmw';
import {IconLightsFogBmw} from './lights-fog-bmw';
import {IconLightsFog} from './lights-fog';
import {IconLightsLowBmw} from './lights-low-bmw';
import {IconLightsLow} from './lights-low';
import {IconLights} from './lights';
import {IconLinkBmw} from './link-bmw';
import {IconLinkNissan} from './link-nissan';
import {IconLink} from './link';
import {IconLinkedin} from './linkedin';
import {IconListBmw} from './list-bmw';
import {IconListNissan} from './list-nissan';
import {IconList} from './list';
import {IconLoader} from './loader';
import {IconLocationBmw} from './location-bmw';
import {IconLocationCctruck} from './location-cctruck';
import {IconLocationGenericV2} from './location-generic-v2';
import {IconLocation} from './location';
import {IconMailBmw} from './mail-bmw';
import {IconMailNissan} from './mail-nissan';
import {IconMail} from './mail';
import {IconMileage} from './mileage';
import {IconMinusBmw} from './minus-bmw';
import {IconMinusNissan} from './minus-nissan';
import {IconMinus} from './minus';
import {IconNavigationSmall} from './navigation-small';
import {IconNewBmw} from './new-bmw';
import {IconNew} from './new';
import {IconOdnoklassniki} from './odnoklassniki';
import {IconOfferBmw} from './offer-bmw';
import {IconOffer} from './offer';
import {IconOilBmw} from './oil-bmw';
import {IconOilThermometer} from './oil-thermometer';
import {IconOil} from './oil';
import {IconParkingBmw} from './parking-bmw';
import {IconParking} from './parking';
import {IconPdf} from './pdf';
import {IconPersonalLkAvito} from './personal-lk-avito';
import {IconPhoneBmw} from './phone-bmw';
import {IconPhoneNissan} from './phone-nissan';
import {IconPhone} from './phone';
import {IconPin} from './pin';
import {IconPin2} from './pin2';
import {IconPlaceholderBmw} from './placeholder-bmw';
import {IconPlaceholderGenericV2} from './placeholder-generic-v2';
import {IconPlaceholderNissan} from './placeholder-nissan';
import {IconPlaceholder} from './placeholder';
import {IconPlusBmw} from './plus-bmw';
import {IconPlusNissan} from './plus-nissan';
import {IconPlus} from './plus';
import {IconPrint} from './print';
import {IconQuestionBmw} from './question-bmw';
import {IconQuestionNissan} from './question-nissan';
import {IconQuestion} from './question';
import {IconRegisterBmw} from './register-bmw';
import {IconRegisterNissan} from './register-nissan';
import {IconRegister} from './register';
import {IconReportVin} from './reportVin';
import {IconRubleInCircle} from './rubleInCircle';
import {IconSearchAvito} from './search-avito';
import {IconSearchBmw} from './search-bmw';
import {IconSearchNissan} from './search-nissan';
import {IconSearch} from './search';
import {IconSeatBmw} from './seat-bmw';
import {IconSeatHeatBmw} from './seat-heat-bmw';
import {IconSeatHeat} from './seat-heat';
import {IconSeat} from './seat';
import {IconSecondaryArrowDownBmw} from './secondary-arrow-down-bmw';
import {IconSecondaryArrowDownNissan} from './secondary-arrow-down-nissan';
import {IconSecondaryArrowDown} from './secondary-arrow-down';
import {IconSecondaryArrowUpBmw} from './secondary-arrow-up-bmw';
import {IconSecondaryArrowUpNissan} from './secondary-arrow-up-nissan';
import {IconSecondaryArrowUp} from './secondary-arrow-up';
import {IconSecondaryCheckBmw} from './secondary-check-bmw';
import {IconSecondaryCheckNissan} from './secondary-check-nissan';
import {IconSecondaryCheck} from './secondary-check';
import {IconSettingsBmw} from './settings-bmw';
import {IconSettingsNissan} from './settings-nissan';
import {IconSettings} from './settings';
import {IconSortAsc} from './sort-asc';
import {IconSortDesc} from './sort-desc';
import {IconSpecPriceBmw} from './spec-price-bmw';
import {IconSpecPrice} from './spec-price';
import {IconSpecVehiclesBmw} from './spec-vehicles-bmw';
import {IconSpecVehicles} from './spec-vehicles';
import {IconStarBmw} from './star-bmw';
import {IconStarNissan} from './star-nissan';
import {IconStar} from './star';
import {IconTelegram} from './telegram';
import {IconTelegram2} from './telegram2';
import {IconTestDriveBmw} from './test-drive-bmw';
import {IconTestDriveNissan} from './test-drive-nissan';
import {IconTestDrive} from './test-drive';
import {IconTiktok} from './tiktok';
import {IconTimeBmw} from './time-bmw';
import {IconTimeNissan} from './time-nissan';
import {IconTime} from './time';
import {IconToolsBmw} from './tools-bmw';
import {IconToolsNissan} from './tools-nissan';
import {IconTools} from './tools';
import {IconTradeInBmw} from './trade-in-bmw';
import {IconTradeInNissan} from './trade-in-nissan';
import {IconTradeIn} from './trade-in';
import {IconTransmissionA2} from './transmission-a-2';
import {IconTransmissionABmw} from './transmission-a-bmw';
import {IconTransmissionA} from './transmission-a';
import {IconTransmissionM2} from './transmission-m-2';
import {IconTransmissionMBmw} from './transmission-m-bmw';
import {IconTransmissionM} from './transmission-m';
import {IconTrashBmw} from './trash-bmw';
import {IconTrashNissan} from './trash-nissan';
import {IconTrash} from './trash';
import {IconTwitter} from './twitter';
import {IconUser2} from './user-2';
import {IconUserBmw} from './user-bmw';
import {IconUserNissan} from './user-nissan';
import {IconUser} from './user';
import {IconVerifiedAvito} from './verified-avito';
import {IconViber} from './viber';
import {IconVideoAvito} from './video-avito';
import {IconVideoButton} from './video-button';
import {IconVideoGrey} from './video-grey';
import {IconVideoPlay} from './video-play';
import {IconVideoPlay2} from './video-play2';
import {IconVideo3} from './video3';
import {IconVisibleAvito} from './visible-avito';
import {IconVkontakte} from './vkontakte';
import {IconWhatsapp} from './whatsapp';
import {IconWheelBack2} from './wheel-back-2';
import {IconWheelBackBmw} from './wheel-back-bmw';
import {IconWheelBack} from './wheel-back';
import {IconWheelFront2} from './wheel-front-2';
import {IconWheelFrontBmw} from './wheel-front-bmw';
import {IconWheelFront} from './wheel-front';
import {IconWheelFull2} from './wheel-full-2';
import {IconWheelFullBmw} from './wheel-full-bmw';
import {IconWheelFull} from './wheel-full';
import {IconWidgetMenu} from './widget-menu';
import {IconWindshieldHeatBmw} from './windshield-heat-bmw';
import {IconWindshieldHeat} from './windshield-heat';
import {IconYandexZen} from './yandex-zen';
import {IconYoutube} from './youtube';
import {IconZzzzzzArrowLeft} from './zzzzzz-arrow-left';
import {IconZzzzzzArrowRight} from './zzzzzz-arrow-right';
import {IconZzzzzzMinus} from './zzzzzz-minus';
import {IconZzzzzzPlus} from './zzzzzz-plus';


const ALL_ICONS: Record<string, FC<Omit<IIconProps, 'name'>>> = {
    '360-avito': Icon360Avito,
    'abs-bmw': IconAbsBmw,
    abs: IconAbs,
    acceleration: IconAcceleration,
    'airbag-bmw': IconAirbagBmw,
    airbag: IconAirbag,
    'arrow-back-oval-avito': IconArrowBackOvalAvito,
    'arrow-down-generic-v2': IconArrowDownGenericV2,
    'arrow-down-nissan': IconArrowDownNissan,
    'arrow-down': IconArrowDown,
    'arrow-green-left-avito': IconArrowGreenLeftAvito,
    'arrow-green-right-avito': IconArrowGreenRightAvito,
    'arrow-left-generic-v2': IconArrowLeftGenericV2,
    'arrow-left-nissan': IconArrowLeftNissan,
    'arrow-left': IconArrowLeft,
    'arrow-right-generic-v2': IconArrowRightGenericV2,
    'arrow-right-nissan': IconArrowRightNissan,
    'arrow-right': IconArrowRight,
    'arrow-up-generic-v2': IconArrowUpGenericV2,
    'arrow-up-nissan': IconArrowUpNissan,
    'arrow-up': IconArrowUp,
    'auto-avito': IconAutoAvito,
    'axle-load-bmw': IconAxleLoadBmw,
    'axle-load': IconAxleLoad,
    'battery-bmw': IconBatteryBmw,
    battery: IconBattery,
    'belt-bmw': IconBeltBmw,
    belt: IconBelt,
    'burger-bmw': IconBurgerBmw,
    'burger-nissan': IconBurgerNissan,
    burger: IconBurger,
    'calc-bmw': IconCalcBmw,
    'calc-nissan': IconCalcNissan,
    calc: IconCalc,
    'calendar-bmw': IconCalendarBmw,
    'calendar-nissan': IconCalendarNissan,
    calendar: IconCalendar,
    'cancel-bmw': IconCancelBmw,
    'cancel-nissan': IconCancelNissan,
    cancel: IconCancel,
    'car-avito': IconCarAvito,
    'car-front-bmw': IconCarFrontBmw,
    'car-front-nissan': IconCarFrontNissan,
    'car-front': IconCarFront,
    'car-seat-left': IconCarSeatLeft,
    'car-seat-right': IconCarSeatRight,
    'carrying-bmw': IconCarryingBmw,
    'carrying-nissan': IconCarryingNissan,
    carrying: IconCarrying,
    'cart-bmw': IconCartBmw,
    'cart-nissan': IconCartNissan,
    cart: IconCart,
    'check-bmw': IconCheckBmw,
    'check-nissan': IconCheckNissan,
    check: IconCheck,
    'checkin-shield-avito': IconCheckinShieldAvito,
    'checkmark-generic-v2': IconCheckmarkGenericV2,
    'chevron-left-bmw': IconChevronLeftBmw,
    'chevron-left-nissan': IconChevronLeftNissan,
    'chevron-left': IconChevronLeft,
    'chevron-right-bmw': IconChevronRightBmw,
    'chevron-right-nissan': IconChevronRightNissan,
    'chevron-right': IconChevronRight,
    'compare-2': IconCompare2,
    compare: IconCompare,
    'document-bmw': IconDocumentBmw,
    'document-nissan': IconDocumentNissan,
    document: IconDocument,
    'download-bmw': IconDownloadBmw,
    'download-nissan': IconDownloadNissan,
    download: IconDownload,
    'eco-bmw': IconEcoBmw,
    eco: IconEco,
    'edit-bmw': IconEditBmw,
    'edit-nissan': IconEditNissan,
    edit: IconEdit,
    'engine-2': IconEngine2,
    'engine-bmw': IconEngineBmw,
    engine: IconEngine,
    'esp-bmw': IconEspBmw,
    'esp-nissan': IconEspNissan,
    esp: IconEsp,
    eye: IconEye,
    facebook: IconFacebook,
    filter: IconFilter,
    foursquare: IconFoursquare,
    'fuel-2': IconFuel2,
    'fuel-bmw': IconFuelBmw,
    fuel: IconFuel,
    globe: IconGlobe,
    'google-plus': IconGooglePlus,
    'grid-nissan': IconGridNissan,
    grid: IconGrid,
    'heart-2': IconHeart2,
    'heart-black': IconHeartBlack,
    heart: IconHeart,
    'height-bmw': IconHeightBmw,
    'height-nissan': IconHeightNissan,
    height: IconHeight,
    'info-bmw': IconInfoBmw,
    'info-nissan': IconInfoNissan,
    info: IconInfo,
    info2: IconInfo2,
    instagram: IconInstagram,
    'interior-avito': IconInteriorAvito,
    'length-bmw': IconLengthBmw,
    length: IconLength,
    'lights-bmw': IconLightsBmw,
    'lights-fog-bmw': IconLightsFogBmw,
    'lights-fog': IconLightsFog,
    'lights-low-bmw': IconLightsLowBmw,
    'lights-low': IconLightsLow,
    lights: IconLights,
    'link-bmw': IconLinkBmw,
    'link-nissan': IconLinkNissan,
    link: IconLink,
    linkedin: IconLinkedin,
    'list-bmw': IconListBmw,
    'list-nissan': IconListNissan,
    list: IconList,
    loader: IconLoader,
    'location-bmw': IconLocationBmw,
    'location-cctruck': IconLocationCctruck,
    'location-generic-v2': IconLocationGenericV2,
    location: IconLocation,
    'mail-bmw': IconMailBmw,
    'mail-nissan': IconMailNissan,
    mail: IconMail,
    mileage: IconMileage,
    'minus-bmw': IconMinusBmw,
    'minus-nissan': IconMinusNissan,
    minus: IconMinus,
    'navigation-small': IconNavigationSmall,
    'new-bmw': IconNewBmw,
    new: IconNew,
    odnoklassniki: IconOdnoklassniki,
    'offer-bmw': IconOfferBmw,
    offer: IconOffer,
    'oil-bmw': IconOilBmw,
    'oil-thermometer': IconOilThermometer,
    oil: IconOil,
    'parking-bmw': IconParkingBmw,
    parking: IconParking,
    pdf: IconPdf,
    'personal-lk-avito': IconPersonalLkAvito,
    'phone-bmw': IconPhoneBmw,
    'phone-nissan': IconPhoneNissan,
    phone: IconPhone,
    pin: IconPin,
    pin2: IconPin2,
    'placeholder-bmw': IconPlaceholderBmw,
    'placeholder-generic-v2': IconPlaceholderGenericV2,
    'placeholder-nissan': IconPlaceholderNissan,
    placeholder: IconPlaceholder,
    'plus-bmw': IconPlusBmw,
    'plus-nissan': IconPlusNissan,
    plus: IconPlus,
    print: IconPrint,
    'question-bmw': IconQuestionBmw,
    'question-nissan': IconQuestionNissan,
    question: IconQuestion,
    'register-bmw': IconRegisterBmw,
    'register-nissan': IconRegisterNissan,
    register: IconRegister,
    reportVin: IconReportVin,
    rubleInCircle: IconRubleInCircle,
    'search-avito': IconSearchAvito,
    'search-bmw': IconSearchBmw,
    'search-nissan': IconSearchNissan,
    search: IconSearch,
    'seat-bmw': IconSeatBmw,
    'seat-heat-bmw': IconSeatHeatBmw,
    'seat-heat': IconSeatHeat,
    seat: IconSeat,
    'secondary-arrow-down-bmw': IconSecondaryArrowDownBmw,
    'secondary-arrow-down-nissan': IconSecondaryArrowDownNissan,
    'secondary-arrow-down': IconSecondaryArrowDown,
    'secondary-arrow-up-bmw': IconSecondaryArrowUpBmw,
    'secondary-arrow-up-nissan': IconSecondaryArrowUpNissan,
    'secondary-arrow-up': IconSecondaryArrowUp,
    'secondary-check-bmw': IconSecondaryCheckBmw,
    'secondary-check-nissan': IconSecondaryCheckNissan,
    'secondary-check': IconSecondaryCheck,
    'settings-bmw': IconSettingsBmw,
    'settings-nissan': IconSettingsNissan,
    settings: IconSettings,
    'sort-asc': IconSortAsc,
    'sort-desc': IconSortDesc,
    'spec-price-bmw': IconSpecPriceBmw,
    'spec-price': IconSpecPrice,
    'spec-vehicles-bmw': IconSpecVehiclesBmw,
    'spec-vehicles': IconSpecVehicles,
    'star-bmw': IconStarBmw,
    'star-nissan': IconStarNissan,
    star: IconStar,
    telegram: IconTelegram,
    telegram2: IconTelegram2,
    'test-drive-bmw': IconTestDriveBmw,
    'test-drive-nissan': IconTestDriveNissan,
    'test-drive': IconTestDrive,
    tiktok: IconTiktok,
    'time-bmw': IconTimeBmw,
    'time-nissan': IconTimeNissan,
    time: IconTime,
    'tools-bmw': IconToolsBmw,
    'tools-nissan': IconToolsNissan,
    tools: IconTools,
    'trade-in-bmw': IconTradeInBmw,
    'trade-in-nissan': IconTradeInNissan,
    'trade-in': IconTradeIn,
    'transmission-a-2': IconTransmissionA2,
    'transmission-a-bmw': IconTransmissionABmw,
    'transmission-a': IconTransmissionA,
    'transmission-m-2': IconTransmissionM2,
    'transmission-m-bmw': IconTransmissionMBmw,
    'transmission-m': IconTransmissionM,
    'trash-bmw': IconTrashBmw,
    'trash-nissan': IconTrashNissan,
    trash: IconTrash,
    twitter: IconTwitter,
    'user-2': IconUser2,
    'user-bmw': IconUserBmw,
    'user-nissan': IconUserNissan,
    user: IconUser,
    'verified-avito': IconVerifiedAvito,
    viber: IconViber,
    'video-avito': IconVideoAvito,
    'video-button': IconVideoButton,
    'video-grey': IconVideoGrey,
    'video-play': IconVideoPlay,
    'video-play2': IconVideoPlay2,
    video3: IconVideo3,
    'visible-avito': IconVisibleAvito,
    vkontakte: IconVkontakte,
    whatsapp: IconWhatsapp,
    'wheel-back-2': IconWheelBack2,
    'wheel-back-bmw': IconWheelBackBmw,
    'wheel-back': IconWheelBack,
    'wheel-front-2': IconWheelFront2,
    'wheel-front-bmw': IconWheelFrontBmw,
    'wheel-front': IconWheelFront,
    'wheel-full-2': IconWheelFull2,
    'wheel-full-bmw': IconWheelFullBmw,
    'wheel-full': IconWheelFull,
    'widget-menu': IconWidgetMenu,
    'windshield-heat-bmw': IconWindshieldHeatBmw,
    'windshield-heat': IconWindshieldHeat,
    'yandex-zen': IconYandexZen,
    youtube: IconYoutube,
    'zzzzzz-arrow-left': IconZzzzzzArrowLeft,
    'zzzzzz-arrow-right': IconZzzzzzArrowRight,
    'zzzzzz-minus': IconZzzzzzMinus,
    'zzzzzz-plus': IconZzzzzzPlus,
};

export interface IIconProps {
    className?: string;
    color?: string;
    name: string;
    size?: string;
    style?: CSSProperties;
}

export const Icon: FC<IIconProps> = (props) => {
    const {
        className,
        color,
        name,
        size,
        style,
    } = props;

    const IconComponent = ALL_ICONS[name];

    if (!IconComponent) {
        return (
            <div>
                Icon not found
                {name}
            </div>
        );
    }

    return (
        <IconComponent
            className={className}
            color={color}
            size={size}
            style={style}
        />
    );
};
